import { useCallback, useMemo, useState } from "react"

import hookSiteSelectedFactory from "@/stores/base-factories/store-site-selection"
import { TODAY } from "@Components/DateRangeButton"
import app from "@Stores/app"
import createStore from "@Stores/base-factories"

import { getGroupByWithDateInterval } from "./utils"

const useBucketReportFactory = ({ fetch, siteSelected }) => {
  const [documents, setDocuments] = useState([])
  const [chartData, setChartData] = useState(null)
  const [chartModal, setChartModal] = useState(null)

  const listTransactions = useCallback(async params => {
    const { key, id } = siteSelected || {}
    const { startDate = TODAY.start, endDate = TODAY.end, allocationBucketId, sortby = [] } = params

    if (!startDate || !endDate || !allocationBucketId) return []

    try {
      const data = await fetch({
        url: `reports/site/${id}/bucket/${allocationBucketId}/transactions`,
        data: {
          startDate: startDate.tz(app.timezone).startOf('day').format(),
          endDate: endDate.tz(app.timezone).endOf('day').format(),
          dateGrouping: getGroupByWithDateInterval({ startDate, endDate }),
          filterby: {
            bucket: [allocationBucketId],
          },
          sortby,
          [key]: id,
        },
        method: 'post',
      })

      setDocuments(data?.documents || [])
      setChartData(data?.metrics || null)
      return data
    } catch (error) {
      setDocuments([])
      setChartData(null)
      return []
    }
  }, [fetch, siteSelected])

  const openChartModal = useCallback(payload => {
    setChartModal(payload)
  }, [])

  const closeChartModal = useCallback(() => {
    setChartModal(null)
    setDocuments([])
    setChartData(null)
  }, [])

  return useMemo(() => ({
    transactions: {
      documents,
      chartData,
      list: listTransactions,
    },
    chartModal: {
      item: chartModal,
      open: openChartModal,
      close: closeChartModal,
    },
  }), [documents, chartData, listTransactions, chartModal, openChartModal, closeChartModal])
}

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendReportFactory()
  .extend(useBucketReportFactory)
  .extendReportViewFactory('bucket')
  .factory()

export {
  Provider as BucketReportProvider,
  useStore as useBucketReportStore,
}
